import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {

  @Input() url: string = '/'; // URL por defecto a la cual redirigir

  constructor(private router: Router) {}

  regresar(): void {
    this.router.navigate([this.url]);
  }
}
